var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 49,
    viewBox: "0 0 45 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7768 16.5182C39.7543 16.5182 39.734 16.5243 39.7117 16.5246C40.1241 15.5705 40.3552 14.5197 40.3552 13.4143C40.3552 9.07963 36.8413 5.56555 32.5066 5.56555C30.9743 5.56555 29.5497 6.0114 28.3416 6.77037C26.7078 2.79863 22.8036 0 18.2426 0C12.2113 0 7.32204 4.88923 7.32204 10.9205C7.32204 11.3762 7.35856 11.8229 7.413 12.264C7.38239 12.2638 7.35287 12.2594 7.32204 12.2594C3.27814 12.2594 0 15.5375 0 19.5816C0 23.6253 3.27793 26.9035 7.32204 26.9035H39.7771C42.6452 26.9035 44.97 24.5787 44.97 21.7107C44.97 18.8428 42.6452 16.518 39.7771 16.518L39.7768 16.5182Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0427 34.0425C14.0427 34.9278 13.3251 35.6453 12.4399 35.6453C11.555 35.6453 10.8372 34.9276 10.8372 34.0425C10.8372 33.1571 11.555 32.4397 12.4399 32.4397C13.3253 32.4397 14.0427 33.1573 14.0427 34.0425Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0877 34.0425C24.0877 34.9278 23.37 35.6453 22.4851 35.6453C21.5995 35.6453 20.8823 34.9276 20.8823 34.0425C20.8823 33.1571 21.5997 32.4397 22.4851 32.4397C23.37 32.4397 24.0877 33.1573 24.0877 34.0425Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0877 46.9192C24.0877 47.8043 23.37 48.522 22.4851 48.522C21.5995 48.522 20.8823 47.8041 20.8823 46.9192C20.8823 46.0338 21.5997 45.3164 22.4851 45.3164C23.37 45.3164 24.0877 46.034 24.0877 46.9192Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7446 40.3474C18.7446 41.2325 18.0269 41.9499 17.1414 41.9499C16.2565 41.9499 15.5388 41.2323 15.5388 40.3474C15.5388 39.462 16.2565 38.7441 17.1414 38.7441C18.0269 38.7441 18.7446 39.462 18.7446 40.3474Z",
    fill: "#FEFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5375 40.3474C29.5375 41.2325 28.8196 41.9499 27.9347 41.9499C27.0491 41.9499 26.3319 41.2323 26.3319 40.3474C26.3319 39.462 27.0493 38.7441 27.9347 38.7441C28.8196 38.7441 29.5375 39.462 29.5375 40.3474Z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1324 34.0425C34.1324 34.9278 33.4145 35.6453 32.5296 35.6453C31.6443 35.6453 30.9264 34.9276 30.9264 34.0425C30.9264 33.1571 31.6443 32.4397 32.5296 32.4397C33.4147 32.4397 34.1324 33.1573 34.1324 34.0425Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeve);
export default __webpack_public_path__ + "static/media/neve.964e4d788e2d43c93b821284fc7abea1.svg";
export { ForwardRef as ReactComponent };